import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//viewer could be the container
import { ViewerComponent } from './components/viewer/viewer.component';

//compoents
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { AnimationEditorComponent } from './components/animation-editor/animation-editor.component';
import { AnimationToolbarComponent } from './components/animation-toolbar/animation-toolbar.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { CuttingPlaneEditorComponent } from './components/cutting-plane-editor/cutting-plane-editor.component';
import { ElementInfoComponent } from './components/element-info/element-info.component';
import { FeatureEditorComponent } from './components/feature-editor/feature-editor.component';
import { GroupboxComponent } from './components/groupbox/groupbox.component';
import { IsoEditorComponent } from './components/iso-editor/iso-editor.component';
import { MainToolbarComponent } from './components/main-toolbar/main-toolbar.component';
import { ModelListComponent } from './components/model-list/model-list.component';
import { PaneComponent } from './components/pane/pane.component';
import { ParticleTraceEditorComponent } from './components/particle-trace-editor/particle-trace-editor.component';
import { ResultsConfigComponent } from './components/results-config/results-config.component';
import { ScalarSettingsEditorComponent } from './components/scalar-settings-editor/scalar-settings-editor.component';
import { SliderTextboxComponent } from './components/slider-textbox/slider-textbox.component';
import { StateSelectComponent } from './components/state-select/state-select.component';

//services
import { AnimationService } from './animation.service';
import { PaneService } from './pane.service';
import { ModelService } from './model.service';
import { C3Service } from './c3.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

//FIX ME
//import { CugService } from './cug.service';

@NgModule({
  declarations: [
    ViewerComponent,
    ContextMenuComponent,
    ToolbarComponent,
    AnimationEditorComponent,
    AnimationToolbarComponent,
    ColorPickerComponent,
    CuttingPlaneEditorComponent,
    ElementInfoComponent,
    FeatureEditorComponent,
    GroupboxComponent,
    IsoEditorComponent,
    MainToolbarComponent,
    ModelListComponent,
    PaneComponent,
    ParticleTraceEditorComponent,
    ResultsConfigComponent,
    ScalarSettingsEditorComponent,
    SliderTextboxComponent,
    StateSelectComponent,
  ],
  imports: [CommonModule, MatCardModule, MatIconModule],
  exports: [
    ViewerComponent,
    AnimationToolbarComponent,
    CuttingPlaneEditorComponent,
    IsoEditorComponent,
    ParticleTraceEditorComponent,
    ResultsConfigComponent,
    MainToolbarComponent,
    ModelListComponent,
    AnimationEditorComponent,
    ElementInfoComponent,
    ScalarSettingsEditorComponent,
  ],
  providers: [
    AnimationService,
    PaneService,
    ModelService,
    C3Service,
    //CugService
  ],
})
export class CeetronModule {}
